'use client';
import Image from '@/components/Image';
import usePageTrack from '../hooks/usePageTrack';

interface PGDescriptionProps {
  title_config: {
    title: string;
    title_color: string;
  };
  description_config: {
    description: string;
    description_color: string;
  };
  bg_color: string;
  image: string;
  isWeb: boolean;
}
export default function PGDescription({
  title_config,
  description_config,
  bg_color,
  image,
  isWeb,
}: PGDescriptionProps) {
  const { trackPageMktClick } = usePageTrack({});
  const wrapperClass = isWeb
    ? `bg-[${bg_color}] px-[200px] py-[38px] flex justify-between items-center`
    : `bg-[${bg_color}] w-full p-[20px_8px]`;
  return (
    <div className={wrapperClass} onClick={() => trackPageMktClick({ module_name: 'PG描述' })}>
      {isWeb ? (
        <>
          <div>
            <h2
              className={`font-be text-[56px]/[68px] text-[${title_config.title_color}] mb-[24px] font-bb`}
            >
              {title_config.title}
            </h2>
            <h3
              className={`text-[${description_config.description_color}] w-[38.75vw]`}
              dangerouslySetInnerHTML={{
                __html: description_config.description,
              }}
            />
          </div>
          <Image src={image} alt="prabal gurung collection" width={430} height={286} />
        </>
      ) : (
        <div className="relative">
          <Image
            src={image}
            alt="Prabal gurung collection"
            width={359}
            height={135}
            className="rounded-[10px] w-full"
          />
          <div className="absolute left-0 top-0 w-full h-full flex justify-center flex-col p-[26px_32px] text-center">
            <h2 className={`text-[${title_config.title_color}] mb-[4px] font-be`}>
              {title_config.title}
            </h2>
            <h3
              className={`text-[${description_config.description_color}] font-ir text-[12px]/[18px]`}
              dangerouslySetInnerHTML={{
                __html: description_config.description,
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
